/**
 * Color Cell Style.
 * @param {*} value
 * @param {object} row
 * @returns {boolean|{css: {"background-color"}}}
 */
window.colorCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        css: {
            "background-color": row.color
        }
    };
};
